<template>
  <div class="moderator-candidate-resumes-passports__passport">
    <BasePreloader v-if="page.pending"/>
    <div class="moderator-candidate-resumes-passports__passport-title">
      Сторінка 1
    </div>
    <FileShow :value="page.passport_page"
              @click.prevent="open = 0"
              class="moderator-candidate-resumes-passports__passport-img"/>


    <div v-if="$get(page, 'passport_page_status.approved')"
         class="moderator-candidate-resumes-passports__passport-footer  _success">
      <span style="color: #16C15B">Підтверджено</span>
      <button @click.prevent="onCancelStatus"
              class="moderator-candidate-resumes-passports__passport-link">
        Відмінити
      </button>
    </div>
    <div v-else-if="$get(page, 'passport_page_status.rejected')"
         class="moderator-candidate-resumes-passports__passport-footer  _rejected">
      <div style="margin-bottom: 0.8rem">
        <span style="opacity: 0.5; font-weight: 500">Причина: </span>
        <span style="">{{ $get(page, 'passport_page_status.reject_reason') }}</span>
      </div>
      <div style="display: flex; justify-content: space-between">
        <div>
          <span style="opacity: 0.5; font-weight: 500">Статус: </span>
          <span style="color: #FF433B">Відхилено</span>
        </div>
        <button @click.prevent="onCancelStatus"
                class="moderator-candidate-resumes-passports__passport-link">
          Відмінити
        </button>
      </div>
    </div>

    <template v-else>
      <BaseInput v-model="reason"
                 placeholder="Прична відмови"
                 textarea
                 :error="error"
                 class="moderator-candidate-resumes-passports__passport-input"/>
      <div class="moderator-candidate-resumes-passports__passport-footer">
        <button v-if="canSetPassportStatus"
                @click.prevent="onApprove"
                class="moderator-candidate-resumes-passports__passport-btn  base-btn  base-btn--outline-blue">
          Підтвердити
        </button>
        <button v-else
                disabled
                class="moderator-candidate-resumes-passports__passport-btn  base-btn  base-btn--outline-blue">
          Підтвердити
        </button>
        <button @click.prevent="onReject"
                class="moderator-candidate-resumes-passports__passport-btn  base-btn  base-btn--outline-orange">
          Відхилити
        </button>
      </div>
    </template>


    <CoolLightBox :items="[page.passport_page]"
                  srcName="path"
                  :index="open"
                  @close="open = null"/>
  </div>
</template>

<script>
  import img from '@/assets/img/iris.jpeg'
  import FileShow from '@/components/FileShow'
  import {mapActions, mapGetters} from 'vuex'

  const CoolLightBox = () => import(/* webpackChunkName: "light-box" */ '../../components/CoolLightBox')

  export default {
    name: 'AMCandidatesResumesPageResumePassportsItem',
    components: {
      FileShow,
      CoolLightBox
    },
    props: {
      page: Object,
      index: Number,
    },
    data() {
      return {
        img,
        reason: null,
        error: null,
        open: null
      }
    },
    computed: {
      ...mapGetters('candidatesResumes', [
        'canSetPassportStatus'
      ])
    },
    methods: {
      ...mapActions('candidatesResumes', [
        'rejectPassportPage',
        'approvePassportPage',
        'cancelStatusPassportPage',
      ]),

      onCancelStatus() {
        this.error = null

        this.cancelStatusPassportPage({
          index: this.index
        })
      },
      onApprove() {
        this.error = null

        this.approvePassportPage({
          index: this.index
        })
      },
      onReject() {
        if (!this.reason) {
          return this.error = 'Для відхилення сторінки повинна бути вказана причина'
        } else {
          this.error = null
        }

        this.rejectPassportPage({
          index: this.index,
          reason: this.reason
        })
      },
    }
  }
</script>

<style lang="less">

</style>
